// L3 — deepest level. Non-recursive. Renders a single leaf row.
import { useState } from "react";
import { Lock } from "lucide-react";
import { RAIL_STATUS_META, effectiveStatus } from "./stageRailUtils";
import RailDependencyTooltip, { RailItemButton } from "./stageRailShared";

export default function StageRailItemL3({
  stage, flatByCode, catalogue, activeCode, onPick, gateStatus,
  phaseVisibility,
}) {
  const [depsOpen, setDepsOpen] = useState(false);
  const state = flatByCode[stage.code] || { status: "not_started" };
  const effStatus = effectiveStatus(stage, state, flatByCode);
  const isLocked = effStatus === "locked";
  const meta = RAIL_STATUS_META[isLocked ? "not_started" : effStatus] || RAIL_STATUS_META.not_started;
  const Icon = isLocked ? Lock : meta.Icon;
  const isActive = activeCode === stage.code;
  const phaseCell = phaseVisibility?.stages?.[stage.code];
  const gate = gateStatus?.[stage.code] || null;

  return (
    <div data-testid={`rail-stage-${stage.code}`}>
      <RailItemButton
        stage={stage} level={3} isLocked={isLocked} isActive={isActive}
        meta={meta} Icon={Icon} hasSubs={false} open={false}
        pad={42} fontSize={11.5}
        phaseCell={phaseCell}
        gate={gate}
        onClick={() => {
          onPick(stage.code);
          if (isLocked) setDepsOpen(!depsOpen);
        }}
      />
      {isLocked && depsOpen && (
        <RailDependencyTooltip stageSpec={stage} flatByCode={flatByCode} catalogue={catalogue} />
      )}
    </div>
  );
}
